<template>
  <div class="width-100p">
    <v-dialog
      v-model="dialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <template #activator="{ on }">
        <v-btn depressed large block color="white" class="ma-0" v-on="on">
          Delete user
        </v-btn>
      </template>

      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11">
              <h2 v-if="canDeleteUser" class="text-h5">Delete user</h2>
              <h2 v-else class="text-h5">Remove user</h2>
            </v-col>
            <v-col cols="1">
              <v-icon
                class="modal-close"
                color="black"
                @click.stop="closeDialog"
                >{{ icons.mdiClose }}</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text class="crud-card-text">
          <p v-if="!canDeleteUser">
            As this user has already activated their account and populated some
            data, we will disassociate them from your company and the user can
            use their profile separately.
          </p>
          <p v-else>
            Are you sure you want to delete this user:<br />
            <b>{{ testatorName }}</b>
          </p>
        </v-card-text>

        <v-card-actions class="crud-card-actions">
          <v-row no-gutters>
            <v-col cols="12">
              <v-btn
                rounded
                depressed
                :loading="buttonLoading"
                color="primary"
                class="left-edit-btn"
                @click="removeUser()"
              >
                <span v-if="canDeleteUser">Yes, Delete User</span>
                <span v-else>Yes, Remove User</span>
                <v-icon small>{{ icons.mdiArrowRight }}</v-icon>
              </v-btn>

              <v-btn
                class="right-edit-btn"
                rounded
                depressed
                outlined
                color="grey.darken1"
                @click="closeDialog()"
              >
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorSnackbar v-model="showError" />
  </div>
</template>

<script>
  import ErrorSnackbar from '../../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../../mixins/form-helper-mixin';
  import { DELETE_TESTATOR_MUTATION } from '../../../constants/graphql/testators';
  import { REMOVE_ADVISOR_MUTATION } from '../../../constants/graphql/advisors';

  export default {
    name: 'DeleteUser',
    components: {
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      testator: {
        required: true,
        type: Object,
      },
      referrerRoute: {
        type: String,
        default: 'AdminPage',
      },
      referrerId: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        dialog: false,
        successMessage: null,
      };
    },
    computed: {
      canDeleteUser() {
        return this.isAdmin || !this.testator.acceptedTerms;
      },
      testatorName() {
        return this.testator.fullName
          ? this.testator.fullName
          : this.testator.email;
      },
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
    },
    methods: {
      removeUser() {
        this.buttonLoading = true;
        this.canDeleteUser ? this.deleteUser() : this.unassignUser();
      },
      deleteUser() {
        const id = this.testator.id;

        this.$apollo
          .mutate({
            mutation: DELETE_TESTATOR_MUTATION,
            variables: {
              id,
            },
          })
          .then(response => {
            if (response.data.deleteTestator.success) {
              this.successMessage = 'User successfully deleted';
              this.redirect();
            } else {
              this.displayErrorAndCloseDialog();
            }
          })
          .catch(error => {
            this.displayErrorAndCloseDialog();
            throw error;
          });
      },
      unassignUser() {
        const testatorId = this.testator.id;
        const sendEmailToAdvisor = false;

        this.$apollo
          .mutate({
            mutation: REMOVE_ADVISOR_MUTATION,
            variables: {
              testatorId,
              sendEmailToAdvisor,
            },
          })
          .then(_data => {
            this.successMessage = 'User successfully removed';
            this.redirect();
          })
          .catch(error => {
            this.displayErrorAndCloseDialog();
            throw error;
          });
      },
      redirect() {
        this.$router.push({
          name: this.referrerRoute,
          params: { id: this.referrerId, successMessage: this.successMessage },
        });
      },
      closeDialog() {
        this.dialog = false;
        this.buttonLoading = false;
      },
    },
  };
</script>
